import { render } from "./AboutLanguages.vue?vue&type=template&id=1b2baa84&scoped=true"
import script from "./AboutLanguages.vue?vue&type=script&lang=js"
export * from "./AboutLanguages.vue?vue&type=script&lang=js"

import "./AboutLanguages.vue?vue&type=style&index=0&id=1b2baa84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2baa84"]])

export default __exports__